import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import YouTubeIcon from '@material-ui/icons/YouTube';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FolderIcon from '@material-ui/icons/Folder';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, ReactHtmlParser } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  RankingAtualizado,
  ItemRanking,
  UserLogado,
  LogoMinhaBunge,
  DivItemNoticia,
  BgImgNoticia,
  DivBtsNoticiaNovidades,
  BtNoticiaNovidades,
  BtNoticiaNovidadesSelecionado,
  VideoTreinamento,
  LinkMaterial,
  NomeCategoriaMaterial,
  DivAcordeon
} from './Estilos'

function MateriaisTreinamentos(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(true);

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));
  const [ IdUser, setIdUser ] = useState(localStorage.getItem("id_tb_user"));
  const [ListMateriais, setListMateriais] = useState([]);
  const [ListaTreinamentos, setListaTreinamentos] = useState([]);
  const [TipoSelecionado, setTipoSelecionado] = useState(0);
  const [SucessoTreinamentos, setSucessoTreinamentos] = useState(true);

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Materiais e Treinamentos")
        PegaMateriais();
        PegaTreinamentos();
    }
  }, []);

  async function PegaMateriais() {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Materiais/ListarTodos`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if(result.sucesso === true) {
          setLoading(false);
          setListMateriais(result.conteudoPasta);
        }
      })
      .catch(error => console.log('error', error));
  }

  async function PegaTreinamentos() {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Treinamentos/ListarTreinamentosTodos`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if(result.sucesso === true) {
          setLoading(false);
          setSucessoTreinamentos(true);
          setListaTreinamentos(result.listaModulosPai);
        } else {
          setSucessoTreinamentos(false);
        }
      })
      .catch(error => console.log('error', error));
  }

  function MudaPesquisa(Tipo) {
      setTipoSelecionado(Tipo)
      if(Tipo === 0){
        LogAcesso(Token, "Materiais")
      } else {
        LogAcesso(Token, "Treinamentos")
      }
  }

  function ItemTreinamento(item, index) {
    return <>
      <VideoTreinamento key={index} target={'_blank'} href={`https://www.youtube.com/watch?v=${item.idYoutube}`}>
          <img src={`http://i3.ytimg.com/vi/${item.idYoutube}/maxresdefault.jpg`} />
          <div className={'TituloVideo'}>{item.tituloVideo}</div>
      </VideoTreinamento>
    </>
  }

  function MostraLinkMaterial(item, index) {
    return <>
      <LinkMaterial key={index} target={'_blank'} href={`https://www.plataformaomnion.com.br/UploadsImagens/AppBunge/Materiais/${item.linkItem}`}>
          <PictureAsPdfIcon />
          <div className={'TextoLink'}>{item.nomeItem}</div>
      </LinkMaterial>
    </>
  }

  function ItemTreinamentoNovo(item, index) {
    return <>
      { item.video !== null ?
      <LinkMaterial key={index} target={'_blank'} href={`https://www.youtube.com/watch?v=${item.video}`}>
          <YouTubeIcon />
          <div className={'TextoLink'}>{item.titulo}</div>
      </LinkMaterial>
      :
      <LinkMaterial key={index} target={'_blank'} href={`https://www.plataformaomnion.com.br/UploadsImagens/AppBunge/Materiais/${item.arquivo}`}>
          <PictureAsPdfIcon />
          <div className={'TextoLink'}>{item.titulo}</div>
      </LinkMaterial>
      }
      
    </>
  }
  
  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>

            <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Materiais e Treinamentos</TitNoticias>
                    <Clear />

                    <DivBtsNoticiaNovidades>
                      {TipoSelecionado == 0 ?
                        <BtNoticiaNovidadesSelecionado>MATERIAIS</BtNoticiaNovidadesSelecionado>
                      :
                        <BtNoticiaNovidades onClick={()=>MudaPesquisa(0)}>MATERIAIS</BtNoticiaNovidades>
                      }
                      {TipoSelecionado == 1 ?
                        <BtNoticiaNovidadesSelecionado>TREINAMENTOS</BtNoticiaNovidadesSelecionado>
                      :
                        <BtNoticiaNovidades onClick={()=>MudaPesquisa(1)}>TREINAMENTOS</BtNoticiaNovidades>
                      }
                    </DivBtsNoticiaNovidades>
                    <Clear />

                    {TipoSelecionado === 0 ?
                      
                      <>
                      {
                      ListMateriais.length > 0 ?
                        ListMateriais.map((item, index) => {
                            return <>

                            <DivAcordeon>
                              <Accordion style={{backgroundColor: 'rgba(0,0,0,0.11)', marginBottom: 10}}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={'panel'+item.id+'a-content'} id={'panel'+item.id+'a-header'}> 
                                  <NomeCategoriaMaterial>
                                    <FolderIcon style={{ color: '#3fb6fc' }} style={{ fontSize: 32 }}/>
                                    <div>{item.titulaPasta}</div>
                                  </NomeCategoriaMaterial>
                                </AccordionSummary>
                                <>

                                {
                                  item.modulos.map((itemx, keyx) => {
                                    return <>
                                      {itemx.moduloDescricao === item.id.toString() ?                                                                        
                                        itemx.conteudoPasta.map((itemxx, keyxx) => {
                                          return MostraLinkMaterial(itemxx, keyxx)
                                        })
                                      :

                                        <Accordion style={{backgroundColor: 'rgba(0,0,0,0.11)', marginBottom: 10, marginLeft: 10, marginRight: 10}}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={'panel'+item.id+'a-content'} id={'panel'+item.id+'a-header'}> 
                                          <NomeCategoriaMaterial>
                                            <FolderIcon style={{ color: '#3fb6fc' }} style={{ fontSize: 32 }}/>
                                            <div>{itemx.moduloDescricao}</div>
                                          </NomeCategoriaMaterial>
                                        </AccordionSummary>

                                        {
                                        itemx.conteudoPasta.map((itemxx, keyyy) => {
                                          return MostraLinkMaterial(itemxx, keyyy)
                                        })
                                        }

                                        </Accordion>

                                      }
                                    </>
                                    
                                  })
                                }

                                </>
                              </Accordion>
                            </DivAcordeon>
         
                            </>
                          })
                      :
                      <div>Carregando...</div>
                      }
                      </>
                    :  
                    SucessoTreinamentos === true ?
                       ListaTreinamentos.length > 0 ?
                        ListaTreinamentos.map((item, index) => {
                          return <>
                            {
                            item.descricaoModuloPai != null ?
                              <>
                                <DivAcordeon>
                                  <Accordion style={{backgroundColor: 'rgba(0,0,0,0.11)', marginBottom: 10}}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={'panel'+item.id+'a-content'} id={'panel'+item.id+'a-header'}> 
                                      <NomeCategoriaMaterial>
                                        <FolderIcon style={{ color: '#3fb6fc' }} style={{ fontSize: 32 }}/>
                                        <div>{item.descricaoModuloPai}</div>
                                      </NomeCategoriaMaterial>
                                    </AccordionSummary>
                                    
                                    {item.listaModulos.map((itemx, keyx) => {

                                      return <>
                                      <Accordion style={{backgroundColor: 'rgba(0,0,0,0.11)', marginBottom: 10, marginRight: 10, marginLeft: 10}}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={'panel'+item.id+'a-content'} id={'panel'+item.id+'a-header'}> 
                                          <NomeCategoriaMaterial>
                                            <div>{itemx.descricaoModulo}</div>
                                          </NomeCategoriaMaterial>
                                        </AccordionSummary>
                                        {
                                          itemx.conteudoTreinamentos.map((itemxx, keyxx) => {
                                            // return <div>{itemxx.titulo}</div>;
                                            return ItemTreinamentoNovo(itemxx, keyxx);
                                          })
                                        }
                                      </Accordion>
                                      </>                                      
                                    })}
                                    
                                    {/* {
                                      item.listaModulos[0].conteudoTreinamentos.map((itemx, keyx) => {
                                        return ItemTreinamentoNovo(itemx, keyx);
                                      })
                                    } */}
                                  </Accordion>
                                </DivAcordeon>
                              </>
                            :
                              <>
                                <DivAcordeon>
                                  <Accordion style={{backgroundColor: 'rgba(0,0,0,0.11)', marginBottom: 10}}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={'panel'+item.id+'a-content'} id={'panel'+item.id+'a-header'}> 
                                      <NomeCategoriaMaterial>
                                        <FolderIcon style={{ color: '#3fb6fc' }} style={{ fontSize: 32 }}/>
                                        <div>{item.listaModulos[0].descricaoModulo}</div>
                                      </NomeCategoriaMaterial>
                                    </AccordionSummary>
                                    {
                                      item.listaModulos[0].conteudoTreinamentos.map((itemx, keyx) => {
                                        return ItemTreinamentoNovo(itemx, keyx);
                                      })
                                    }
                                  </Accordion>
                                </DivAcordeon>
                              </>                            
                            }
                          </>
                        })
                      :
                      <div>Carregando...</div>
                      :
                      <>Nenhuma informação para exibir.</>
                    }
                </div>
            </ColunaRegras>
            
            <MenuPrinc Pagina="Conteudos" />
         </BackgroundImg>
    </>
  );

}

export default MateriaisTreinamentos;
